import { SIGNATURE } from "@/data/content";

export default function Marquee() {
  const items = [...SIGNATURE, ...SIGNATURE, ...SIGNATURE, ...SIGNATURE];
  return (
    <div data-testid="signature-marquee" className="overflow-hidden border-y border-deep/10 bg-sand/50 py-8">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-10 font-serif text-3xl font-light italic text-deep/70 md:text-5xl">
                  {w}
                </span>
                <span className="h-2 w-2 rounded-full bg-gold" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
